import { Badge, Fieldset, Group, Stack, Text } from "@mantine/core"
import { InformationRequestStatus } from "@tfg/db"
import { CopyButton } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { RequestItemInformation } from "~/pages/SupplierPortal/TraceabilityRequests/components/RequestItemInformation"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"

interface InformationRequestSummaryProps {
  adminButtons: React.ReactNode
}

export const InformationRequestSummary = ({
  adminButtons,
}: InformationRequestSummaryProps) => {
  const { t } = useTranslation("traceability")

  const { canSubmitIR, request, status, isAdmin } =
    useInformationRequestContext()
  return (
    <Fieldset
      styles={{ legend: { width: "100%" } }}
      legend={
        status === InformationRequestStatus.OPENED ? (
          <Badge size="lg" w="100%" color={canSubmitIR ? "yellow" : "red"}>
            {canSubmitIR ? t("request.complete") : t("request.incomplete")}
          </Badge>
        ) : (
          <Badge size="lg" w="100%" color="green.5">
            {t("requests.tabs.closed")}
          </Badge>
        )
      }
    >
      <Stack gap="xs">{adminButtons}</Stack>
      {isAdmin && (
        <CopyButton
          label="Information Request Id"
          copyableText={request.original.id.toString()}
          admin={true}
          size="xs"
        />
      )}
      <RequestItemInformation
        request={request.original}
        issuer={request.original.issuer}
      />
      {isAdmin ? (
        <>
          <Group justify="space-between" wrap="nowrap">
            <Text fz="sm" fw={700} c="violet">
              Product Id
            </Text>
            <CopyButton
              label="Product Id"
              size="xs"
              copyableText={request.original.productId?.toString() || ""}
              admin={isAdmin}
            />
          </Group>
          {request.original.item.type !== "product" && (
            <Group justify="space-between" wrap="nowrap">
              <Text fz="sm" fw={700} c="violet">
                Product Name
              </Text>
              <Text c="violet" fz="sm">
                {request.original.productName}
              </Text>
            </Group>
          )}
        </>
      ) : null}
    </Fieldset>
  )
}
